import home from '@/views/zhigongxiaojia/home.vue'
import workspace from '@/views/zhigongxiaojia/workspace.vue'
import declare from '@/views/zhigongxiaojia/declare.vue'
import dealList from '@/views/zhigongxiaojia/dealList.vue'
export default [{
  path: '/zhigongxiaojia',
  name: 'zhigongxiaojia',
  meta: {
    title: '首页',
    NeedLogin: false,
    keepAlive: true
  },
  component: home
}, {
  path: '/zhigongxiaojia/workspace',
  name: 'zhigongxiaojiaWorkspace',
  meta: {
    title: '工作台',
    NeedLogin: false,
    keepAlive: false
  },
  component: workspace,
  children: [{
    path: 'declare',
    name: 'zhigongxiaojiaWorkspaceDeclare',
    meta: {
      title: '小家申报',
      NeedLogin: false,
      keepAlive: false
    },
    component: declare
  }, {
    path: 'dealList',
    name: 'zhigongxiaojiaWorkspaceDealList',
    meta: {
      title: '信息处理',
      NeedLogin: false,
      keepAlive: false
    },
    component: dealList
  },
  {
    path: 'userList',
    name: 'zhigongxiaojiaWorkspaceUserList',
    meta: {
      title: '账号管理',
      NeedLogin: false,
      keepAlive: false
    },
    component: resolve => {
      require(['../views/zhigongxiaojia/workspace_zhgl.vue'], resolve)
    }
  }
  ]
}, {
  path: '/zhigongxiaojia/declareDetail/:id',
  name: 'shenbaojieguoDeclareDetail',
  meta: {
    title: '申报详情',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhigongxiaojia/declareDetail.vue'], resolve)
  }
},
{
  path: '/zhigongxiaojia/declareEdit/:id',
  name: 'zhigongxiaojiaDeclareEdit',
  meta: {
    title: '小家申报',
    NeedLogin: false,
    keepAlive: false
  },
  component: declare
},
{
  path: '/zhigongxiaojia/create',
  name: 'create',
  meta: {
    title: '新增人员',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhigongxiaojia/xinzengrenyuan.vue'], resolve)
  }
},
{
  path: '/zhigongxiaojia/detail',
  name: 'detail',
  meta: {
    title: '小家详情',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhigongxiaojia/xiaojiaxiangqing.vue'], resolve)
  }
},
{
  path: '/zhigongxiaojia/modify',
  name: 'modify',
  meta: {
    title: '修改人员',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhigongxiaojia/modify.vue'], resolve)
  }
},
{
  path: '/zhigongxiaojia/hgsc',
  name: 'test',
  meta: {
    title: '惠工商城',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhigongxiaojia/test.vue'], resolve)
  }
},
{
  path: '/zhigongxiaojia/test',
  name: 'test2',
  meta: {
    title: 'test',
    NeedLogin: false,
    keepAlive: false
  },
  component: resolve => {
    require(['../views/zhigongxiaojia/test2.vue'], resolve)
  }
}
]
